import Button from '@ui/buttons/button/button';
import SlideDownCard from '@ui/cards/slide-down-card/slide-down-card';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
// import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import SelectSingle from '@ui/select/react-select/select-single';
// import TextArea from '@ui/text-area/text-area';
import { memo, useState } from 'react';
import { fontFamilyOptions } from '../constants';
import Icon from '@ui/icons/icon';
import classes from '../campaign-editor.module.css';

interface Props {
  headingFont: string;
  bodyFont: string;
  setHeadingFont: (str: string) => void;
  setBodyFont: (str: string) => void;
}
function CampaignEditorTextInputs({ headingFont, setHeadingFont, bodyFont, setBodyFont }: Props) {
  const [textOpen, setTextOpen] = useState(true);
  return (
    <Container padding="0 12px">
      <Container
        style={{ transition: 'border-radius 350ms' }}
        borderRadius={textOpen ? '16px' : '12px'}
        design="GlobalCont2"
      >
        <Container>
          <Button
            className="flex jc-space-between ai-center width-100-percent"
            onClick={() => setTextOpen((prev) => !prev)}
          >
            <Text className="H6" design="GlobalIcoText1">
              Fonts
            </Text>
            <div style={{ transform: textOpen ? `rotate(90deg)` : undefined }}>
              <Icon name={ICONS.ANGLE_RIGHT} size={12} />
            </div>
          </Button>
        </Container>
        <SlideDownCard autoGrow open={textOpen} animateOnInitialLoad={false}>
          <Container padding="0 0 8px 0">
            <div className={classes.fieldRow}>
              <Text design="GlobalIcoText3" tag="label" className="L2">
                Heading
              </Text>
              <SelectSingle
                value={headingFont}
                options={fontFamilyOptions}
                onChange={setHeadingFont}
                placeholder="Heading Font"
                width="100%"
              />
            </div>
            <div className={classes.fieldRow}>
              <Text design="GlobalIcoText3" tag="label" className="L2">
                Body
              </Text>
              <SelectSingle
                value={bodyFont}
                options={fontFamilyOptions}
                onChange={setBodyFont}
                placeholder="Body Font"
                width="100%"
              />
            </div>
          </Container>
        </SlideDownCard>
      </Container>
    </Container>
  );
}

export default memo(CampaignEditorTextInputs);
